/**
 * @generated SignedSource<<9d06d21c9cb7601c0462a82311510c0b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoPriority = "DEFAULT" | "HIGH" | "LOW" | "URGENT";
import { FragmentRefs } from "relay-runtime";
export type useTodoEditSetPrio_todo$data = {
  readonly id: string;
  readonly ordinal: string;
  readonly priority: TodoPriority;
  readonly " $fragmentType": "useTodoEditSetPrio_todo";
};
export type useTodoEditSetPrio_todo$key = {
  readonly " $data"?: useTodoEditSetPrio_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"useTodoEditSetPrio_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useTodoEditSetPrio_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priority",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ordinal",
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "0b385a9142fe9b25a02bbb388cbee2f2";

export default node;
